import { useQuery } from "@tanstack/react-query";
import React from "react";
import Swal from "sweetalert2";
import Loading from "../../../components/Loading/Loading";

const ManageDoctors = () => {
  // Fetch Doctors data with jwt token
  const {
    data: doctors,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["doctors"],
    queryFn: async () => {
      try {
        const res = await fetch(
          "https://doctors-portal-server-azure.vercel.app/doctors",
          {
            headers: {
              authorization: "Bearer " + localStorage.getItem("doctors_token"),
            },
          }
        );
        const data = await res.json();
        return data;
      } catch (err) {
        console.log(err);
      }
    },
  });

  if (isLoading) {
    return <Loading />;
  }

  const handleDoctorDelete = ({ _id, name, image }) => {
    Swal.fire({
      title: `Delete ${name} ?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`https://doctors-portal-server-azure.vercel.app/doctors/${_id}`, {
          method: "DELETE",
          headers: {
            authorization: "Bearer " + localStorage.getItem("doctors_token"),
          },
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.deletedCount) {
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
              refetch();
            }
          });
      }
    });
  };

  return (
    <section className="bg-[#F1F5F9] px-14 py-7 min-h-screen">
      {/* Manage Doc header */}
      <div className="flex justify-between items-center py-7">
        <p className="text-lg font-medium">Manage Doctors: {doctors?.length}</p>
      </div>
      {/* Table */}
      <div className="overflow-x-auto">
        <table className="table w-full">
          <thead>
            <tr>
              <th></th>
              <th>Avatar</th>
              <th>Name</th>
              <th>Speciality</th>
              <th>Active</th>
            </tr>
          </thead>
          <tbody>
            {doctors?.map((doctor, index) => (
              <tr className="hover" key={doctor._id}>
                {console.log(doctor)}
                <th>{++index}</th>
                <td>
                  <div className="avatar">
                    <div className="w-16 mask mask-squircle">
                      <img src={doctor.image} alt={doctor.name} />
                    </div>
                  </div>
                </td>
                <td>{doctor.name}</td>
                <td>{doctor.speciality}</td>
                <td>
                  <button
                    onClick={() => handleDoctorDelete(doctor)}
                    htmlFor="deleteDoctorModal"
                    className="btn btn-sm z-50"
                  >
                    Delete
                  </button>
                  {/* <button className="btn btn-sm">Delete</button> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default ManageDoctors;
